<template>
  <div>
    <div v-if="!isPanel">
      <!-- 読み方向 -->
      <label>{{ lang.page_progression_direction }}</label>
      <v-radio-group
        class="ma-0"
        :value="pageProgressionDirection"
        @change="onClickUpdatePageProgressionDirection"
        row
      >
        <div :class="$style.pageProgressionDirection__item">
          <v-radio value="rtl"></v-radio>
          <img
            width="68px"
            src="./assets/page_progression_direction_rtl.png"
            @click="onClickUpdatePageProgressionDirection('rtl')"
          />
        </div>

        <div :class="$style.pageProgressionDirection__item">
          <v-radio value="ltr"></v-radio>
          <img
            width="68px"
            src="./assets/page_progression_direction_ltr.png"
            @click="onClickUpdatePageProgressionDirection('ltr')"
          />
        </div>

        <div :class="$style.pageProgressionDirection__item">
          <v-radio value="vertical"></v-radio>
          <img
            width="68px"
            src="./assets/page_progression_direction_vertical.png"
            @click="onClickUpdatePageProgressionDirection('vertical')"
          />
        </div>
      </v-radio-group>
    </div>

    <v-btn
      color="pink"
      :class="[$style.btnTextStyle, 'white--text mx-0 mt-0 mb-2']"
      :disabled="isPanel && images.length > 0"
      @click="onClickAddImageDialog"
    >
      {{ lang.image_add }}
      <v-icon right dark>add</v-icon>
    </v-btn>

    <div class="grey--text text--darken-1 pb-3">{{ imageAddNote }}</div>

    <template v-if="!isPanel && getNotIncludeCoverDataImageCount > 0">
      <v-card
        class="text-xs-center body-2 orange darken-2 pa-1 white--text"
        flat
        max-width="60"
      >
        {{ lang.hint_card_text }}
      </v-card>
      <v-responsive class="mb-5" max-width="100%">
        <ul class="ml-4 pt-1 body-2">
          <li
            v-if="getNotIncludeCoverDataImageCount > 1 && checkMobile === false"
          >
            {{ lang.rearrange_hint_pc }}
          </li>
          <li
            v-if="getNotIncludeCoverDataImageCount > 1 && checkMobile === true"
          >
            {{ lang.rearrange_hint_smartphone }}
          </li>
          <li>{{ lang.display_cover_hint_text1 }}</li>
          <li>{{ lang.display_cover_hint_text2 }}</li>
        </ul>
      </v-responsive>
    </template>

    <!-- アップロード画像表示・編集エリア -->
    <div :class="$style.imageEditArea">
      <!-- 実体（draggable） -->
      <div :class="$style.imageEditAreaContainer">
        <draggable
          v-model="myImages"
          :move="beforeMove"
          :options="{
            animation: 150,
            ghostClass: $style.dragGhostItem
          }"
        >
          <transition-group
            :class="$style.pages"
            :style="{ flexDirection: flexDirection, width: wrapperWidth }"
          >
            <li
              v-for="(element, index) in myImages"
              :key="index"
              :class="[
                {
                  [frontCoverPageAreaMargin]: element.name === 'frontCoverImage'
                },
                $style.imageItem,
                {
                  [$style.hasMargin]:
                    pageProgressionDirection === 'vertical' || isPanel
                }
              ]"
              :style="[
                !(element.name === 'backCoverImage') &&
                !(index % 2) &&
                (pageProgressionDirection !== 'vertical' || isPanel)
                  ? imageLeftAndRightMargin(true)
                  : imageLeftAndRightMargin(false),
                myImages.length - 2 === index ? lastImageMargin : ''
              ]"
            >
              <!-- パネル画像 -->
              <v-card v-if="isPanel">
                <div
                  v-if="!element.notMove"
                  @click="openDetailImage(index, element.imageId)"
                >
                  <div
                    v-if="!element.isBlank"
                    :class="$style.panelImageWrapper"
                  >
                    <img :class="$style.panelImage" :src="element.src" />
                  </div>
                </div>
              </v-card>
              <v-card v-else :class="$style.borderPosition" :style="imageSize">
                <!-- 表紙1 -->
                <div
                  v-if="!isPanel && element.name === 'frontCoverImage'"
                  @click="
                    selectFrontCoverImageDialog = !selectFrontCoverImageDialog
                  "
                >
                  <div :class="$style.imageWrapper" :style="imageSize">
                    <img :class="$style.listImage" :src="frontCoverImageUrl" />

                    <p
                      :class="[
                        $style.facingPageBorderPageText,
                        'text-xs-center',
                        {
                          caption: $vuetify.breakpoint.smAndDown,
                          subheading: $vuetify.breakpoint.mdAndUp
                        }
                      ]"
                    >
                      <span> {{ lang.front_cover_title }} </span>
                    </p>
                  </div>
                </div>

                <!-- 表紙2 -->
                <div
                  v-if="
                    !isPanel &&
                      element.staticImageName === 'frontCoverNextImage'
                  "
                  @click="
                    openDetailStaticImage(index, element.imageId, 'frontNext')
                  "
                >
                  <div :class="$style.imageWrapper" :style="imageSize">
                    <img
                      v-if="element.src"
                      :class="$style.listImage"
                      :src="element.src"
                    />

                    <p
                      :class="[
                        $style.facingPageBorderPageText,
                        'text-xs-center',
                        {
                          caption: $vuetify.breakpoint.smAndDown,
                          subheading: $vuetify.breakpoint.mdAndUp
                        }
                      ]"
                    >
                      <span> {{ lang.front_cover_next_title }} </span>
                    </p>
                  </div>
                </div>

                <!-- 表紙3 -->
                <div
                  v-if="
                    !isPanel && element.staticImageName === 'backCoverPrevImage'
                  "
                  @click="
                    openDetailStaticImage(index, element.imageId, 'backPrev')
                  "
                >
                  <div :class="$style.imageWrapper" :style="imageSize">
                    <img
                      v-if="element.src"
                      :class="$style.listImage"
                      :src="element.src"
                    />

                    <p
                      :class="[
                        $style.facingPageBorderPageText,
                        'text-xs-center',
                        {
                          caption: $vuetify.breakpoint.smAndDown,
                          subheading: $vuetify.breakpoint.mdAndUp
                        }
                      ]"
                    >
                      <span> {{ lang.back_cover_prev_title }} </span>
                    </p>
                  </div>
                </div>

                <!-- 表紙4 -->
                <div
                  v-if="!isPanel && element.name === 'backCoverImage'"
                  @click="
                    selectBackCoverImageDialog = !selectBackCoverImageDialog
                  "
                >
                  <div :class="$style.imageWrapper" :style="imageSize">
                    <img :class="$style.listImage" :src="backCoverImageUrl" />

                    <p
                      :class="[
                        $style.facingPageBorderPageText,
                        'text-xs-center',
                        {
                          caption: $vuetify.breakpoint.smAndDown,
                          subheading: $vuetify.breakpoint.mdAndUp
                        }
                      ]"
                    >
                      <span>{{ lang.back_cover_title }}</span>
                    </p>
                  </div>
                </div>

                <!-- 本文 -->
                <div
                  v-if="!element.notMove"
                  @click="openDetailImage(index, element.imageId)"
                >
                  <div :class="$style.imageWrapper" :style="imageSize">
                    <!-- ページ画像 -->
                    <img
                      v-if="!element.isBlank"
                      :class="$style.listImage"
                      :src="element.src"
                    />
                  </div>
                </div>
              </v-card>
              <div v-if="isPanel" :class="$style['page-number-wrapper']">
                <span>{{ element.name }}</span>
              </div>
              <div
                v-else
                :class="$style['page-number-wrapper']"
                :style="{
                  width: imageSize.width,
                  color:
                    element.staticImageName === 'blankArea' ||
                    element.name === 'blankImage'
                      ? 'transparent'
                      : ''
                }"
              >
                <span
                  v-if="
                    (element.name === 'frontCoverImage' &&
                      !userFrontCoverImageUrl) ||
                      (element.name === 'backCoverImage' &&
                        !userBackCoverImageUrl)
                  "
                >
                  {{ lang.default_cover_name }}
                </span>
                <span
                  v-else-if="
                    element.name === 'frontCoverImage' ||
                      element.name === 'backCoverImage'
                  "
                >
                  <span v-if="element.name === 'frontCoverImage'">
                    {{ coverImageFileName(element, "frontCoverImage") }}
                  </span>
                  <span v-else-if="element.name === 'backCoverImage'">
                    {{ coverImageFileName(element, "backCoverImage") }}
                  </span>
                </span>
                <span v-else>{{ element.name }}</span>
              </div>
            </li>
          </transition-group>
        </draggable>
      </div>

      <!-- 見開きページごとにボーダー設定 -->
      <div
        :class="$style.facingPageBorderArea"
        v-if="
          !isPanel &&
            (pageProgressionDirection === 'ltr' ||
              pageProgressionDirection === 'rtl')
        "
      >
        <div
          :class="$style.pages"
          :style="{ flexDirection: flexDirection, width: wrapperWidth }"
        >
          <li
            v-for="(element, index) in myImages"
            :key="index"
            :class="[
              {
                [frontCoverPageAreaMargin]: element.name === 'frontCoverImage'
              },
              $style.imageItem,
              $style.borderPosition,
              {
                [$style.hasMargin]:
                  pageProgressionDirection === 'vertical' || isPanel
              }
            ]"
            :style="[
              !(element.name === 'backCoverImage') && !(index % 2)
                ? imageLeftAndRightMargin(true)
                : imageLeftAndRightMargin(false),
              myImages.length - 2 === index ? lastImageMargin : ''
            ]"
          >
            <v-card :class="$style.borderPosition" :style="imageSize">
              <!-- 表紙、裏表紙の枠 -->
              <div
                v-if="
                  element.name === 'frontCoverImage' ||
                    element.name === 'backCoverImage'
                "
                :class="$style.coverImageBorder"
                :style="coverPageAreaBorderSize"
              ></div>

              <!-- 表紙2の枠 -->
              <div
                v-if="
                  pageProgressionDirection === 'ltr' &&
                    element.staticImageName === 'frontCoverNextImage'
                "
                :class="$style.facingPageBorder"
                :style="facingPageAreaBorderSize"
              ></div>

              <!-- 表紙3の枠 -->
              <div
                v-if="
                  pageProgressionDirection === 'rtl' &&
                    element.staticImageName === 'backCoverPrevImage'
                "
                :class="$style.facingPageBorder"
                :style="facingPageAreaBorderSize"
              ></div>

              <!-- 本体の画像 -->
              <div
                v-if="!element.notMove && !hasMargin(index)"
                :class="$style.facingPageBorder"
                :style="facingPageAreaBorderSize"
              ></div>

              <!-- 空白 -->
              <div
                v-if="
                  pageProgressionDirection === 'ltr' &&
                    element.staticImageName === 'blankArea'
                "
                :class="$style.facingPageBorder"
                :style="facingPageAreaBorderSize"
              ></div>
            </v-card>
            <div
              :class="$style['page-number-wrapper']"
              :style="{ width: imageSize.width, color: 'transparent' }"
            >
              <span
                v-if="
                  (element.name === 'frontCoverImage' &&
                    !userFrontCoverImageUrl) ||
                    (element.name === 'backCoverImage' &&
                      !userBackCoverImageUrl)
                "
                >{{ lang.default_cover_name }}</span
              >
              <span
                v-else-if="
                  element.name === 'frontCoverImage' ||
                    element.name === 'backCoverImage'
                "
              >
                <span v-if="element.name === 'frontCoverImage'">
                  {{ coverImageFileName(element, "frontCoverImage") }}
                </span>
                <span v-else-if="element.name === 'backCoverImage'">
                  {{ coverImageFileName(element, "backCoverImage") }}
                </span>
              </span>
              <span v-else>{{ element.name }}</span>
            </div>
          </li>
        </div>
      </div>
    </div>

    <!-- 画像アップロードダイアログ -->
    <v-dialog v-model="addImageDialog" max-width="500px">
      <v-card>
        <v-card-title> {{ lang.image_add_dialog_title }} </v-card-title>

        <connect-vc-share-imageupload
          v-if="addImageDialog"
          v-on:start-upload="addImageDialog = false"
          :lang="lang"
          :is-panel="isPanel"
        ></connect-vc-share-imageupload>

        <v-card-actions>
          <v-btn
            :class="$style.btnTextStyle"
            color="primary"
            flat
            @click="addImageDialog = false"
          >
            {{ lang.image_add_dialog_close }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 画像表示ダイアログ -->
    <v-dialog v-model="showDetailModal" max-width="500px">
      <v-card v-if="showDetailModal">
        <v-card-title>
          ID:
          <span v-if="pageProgressionDirection === 'vertical' || isPanel">{{
            detailImage.index + 1
          }}</span>
          <span v-else>{{ detailImage.index - 1 }}</span> /
          {{ getNotIncludeCoverDataImageCount }}
        </v-card-title>

        <div :class="[$style.detailImageWrapper]">
          <img
            :class="$style.detailPreviewImage"
            :src="myImages[detailImage.index].src"
          />

          <div>
            <v-btn
              color="grey darken-1"
              :class="[$style.btnTextStyle, 'white--text']"
              @click="
                onClickDeleteDraftImage(
                  myImages[detailImage.index].imageId,
                  myImages[detailImage.index]
                )
              "
              v-bind:disabled="!isActiveImage(detailImage.index)"
              :loading="myImages[detailImage.index].isDeleting"
            >
              {{ lang.image_delete }}
              <v-icon right dark>delete</v-icon>
            </v-btn>
          </div>

          <div :class="[$style.detailImageButton, $style.left]">
            <v-btn
              dark
              large
              flat
              icon
              color="primary"
              v-if="isShowPrev"
              @click="getPrevImage()"
            >
              <v-icon x-large>chevron_left</v-icon>
            </v-btn>
          </div>

          <div :class="[$style.detailImageButton, $style.right]">
            <v-btn
              dark
              large
              flat
              icon
              color="primary"
              v-if="isShowNext"
              @click="getNextImage()"
            >
              <v-icon x-large>chevron_right</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card-actions>
          <v-btn
            :class="$style.btnTextStyle"
            color="primary"
            flat
            @click="showDetailModal = false"
          >
            {{ lang.image_detail_dialog_close }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 表紙選択ダイアログ -->
    <vc-share-comic-cover-select-dialog
      :show-dialog="selectFrontCoverImageDialog"
      :cover-type="frontCoverType"
      :is-front-cover="true"
      :user-cover-image-url="userFrontCoverImageUrl"
      :update-cover-type="updateFrontCoverType"
      :post-cover-image="postFrontCoverImage"
      :is-busy="isBusy"
      :is-firefox="isFirefox"
      :is-android-os="isAndroidOs"
      :is-ice="isIce"
      :lang="lang"
      @updateShowCoverDialog="updateShowCoverDialog"
    >
      <span slot="header">{{ lang.front_cover_title }}</span>
    </vc-share-comic-cover-select-dialog>

    <!-- 裏表紙選択ダイアログ -->
    <vc-share-comic-cover-select-dialog
      :show-dialog="selectBackCoverImageDialog"
      :cover-type="backCoverType"
      :is-front-cover="false"
      :user-cover-image-url="userBackCoverImageUrl"
      :update-cover-type="updateBackCoverType"
      :post-cover-image="postBackCoverImage"
      :is-busy="isBusy"
      :is-firefox="isFirefox"
      :is-android-os="isAndroidOs"
      :is-ice="isIce"
      :lang="lang"
      @updateShowCoverDialog="updateShowCoverDialog"
    >
      <span slot="header">{{ lang.back_cover_title }}</span>
    </vc-share-comic-cover-select-dialog>

    <!-- 表2・3アップロードダイアログ -->
    <v-dialog v-model="staticImageDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span v-if="uploadStaticImageType === 'frontNext'">{{
            lang.front_cover_next_title
          }}</span>
          <span v-if="uploadStaticImageType === 'backPrev'">{{
            lang.back_cover_prev_title
          }}</span>
        </v-card-title>

        <div
          v-if="
            (uploadStaticImageType === 'frontNext' && isSetFrontCoverNext) ||
              (uploadStaticImageType === 'backPrev' && isSetBackCoverPrev)
          "
          :class="[$style.detailImageWrapper]"
        >
          <img
            :class="$style.detailPreviewImage"
            :src="myImages[detailImage.index].src"
          />

          <div>
            <v-btn
              color="grey darken-1"
              :class="[$style.btnTextStyle, 'white--text']"
              @click="
                onClickDeleteDraftImage(
                  myImages[detailImage.index].imageId,
                  myImages[detailImage.index]
                )
              "
              v-bind:disabled="!isActiveImage(detailImage.index)"
              :loading="myImages[detailImage.index].isDeleting"
            >
              {{ lang.image_delete }}
              <v-icon right dark>delete</v-icon>
            </v-btn>
          </div>
        </div>

        <template v-else>
          <v-flex
            xs12
            class="text-xs-center text-sm-center text-md-center text-lg-center"
          >
            <v-btn
              color="primary"
              :class="$style.btnTextStyle"
              @click="onClickStaticImageFile()"
            >
              {{ lang.cover_edit_dialog_select_file }}
            </v-btn>

            <input
              type="file"
              style="display: none"
              ref="staticImageFileInput"
              accept="image/png,image/jpeg, image/jpg"
              @change="onChangeStaticImageFileInput"
            />
            <v-alert
              v-for="(message, key, index) in errorMessages"
              :key="index"
              :value="true"
              type="error"
            >
              {{ message }}
            </v-alert>
          </v-flex>
        </template>

        <v-card-actions>
          <v-btn
            :class="$style.btnTextStyle"
            color="primary"
            flat
            @click="staticImageDialog = false"
          >
            {{ lang.image_add_dialog_close }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import log from "loglevel";
import CoverDefault from "./assets/default_cover_simple.png";
import ComicCoverSelectDialog from "./ComicCoverSelectDialog.vue";

import ua from "../../../lib/useragent.js";
import {
  dataUrlToBlob,
  loadImageWithOrientationCorrection
} from "../../../lib/image.js";

const MAX_IMAGE_FILE_SIZE_HUMAN = 32;
const MAX_IMAGE_FILE_SIZE = 1024 * 1024 * MAX_IMAGE_FILE_SIZE_HUMAN;
const COVER_TYPE_SIMPLE = "simple";

export default {
  name: "vc-share-comic-editor",
  components: {
    draggable,
    "vc-share-comic-cover-select-dialog": ComicCoverSelectDialog
  },
  props: {
    lang: {
      type: Object,
      default: () => ({
        page_progression_direction: "読む方向",
        image_add: "新規画像の追加",
        image_add_note: "*1枚:max_sizeMBまでのPNGまたはJPEG（最大:num枚）",
        image_add_dialog_title: "画像追加",
        image_add_dialog_close: "Close",
        image_delete: "この画像を削除する",
        image_detail_dialog_close: "Close",
        alert_multiple_images_for_panel:
          "複数ファイルが選択されているためこの設定は選択できません。",
        cover_edit_error_image_size:
          ":filename : :max_size MB より小さい画像を選択してください。",
        cover_edit_error_file_type:
          ":filename : jpeg もしくは png の画像を選択してください。",
        cover_edit_error_read_image_failure: "画像の読み込みに失敗しました。",
        cover_edit_dialog_select_file: "ファイルを選択",
        rearrange_hint_pc:
          "選択した画像はドラッグ＆ドロップによる入れ替えができます。",
        rearrange_hint_smartphone:
          "選択した画像はドラッグ＆ドロップによる入れ替えができます。",
        display_cover_hint_text1:
          "表紙／裏表紙は任意の画像を表示したい場合のみ設定します",
        display_cover_hint_text2:
          "表紙／裏表紙を既定のままにした場合、2D表示で表紙はスキップされます",
        front_cover_title: "表紙",
        back_cover_title: "裏表紙",
        default_cover_name: "規定シンプル",
        cover_edit_dialog_apply: "適用",
        cover_edit_dialog_cancel: "キャンセル",
        cover_edit_dialog_nothing_file: "ファイルが選択されていません",
        cover_edit_error_require_file: "画像を選択してください",
        front_cover_next_title: "表紙 (裏)",
        back_cover_prev_title: "裏表紙 (裏)"
      })
    },

    //state
    draftId: {
      type: Number,
      default: null
    },
    pageProgressionDirection: {
      type: String,
      default: "rtl"
    },
    images: {
      type: Array,
      default: function() {
        return [];
      }
    },
    isSetFrontCover: {
      type: Boolean,
      default: false
    },
    userFrontCoverImageUrl: {
      type: String,
      default: ""
    },
    userBackCoverImageUrl: {
      type: String,
      default: ""
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    frontCoverType: {
      type: String,
      default: "simple"
    },
    backCoverType: {
      type: String,
      default: "simple"
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    isSetFrontCoverNext: {
      type: Boolean,
      default: false
    },
    isSetBackCoverPrev: {
      type: Boolean,
      default: false
    },
    frontCoverNextData: {
      type: Object,
      default: () => {}
    },
    backCoverPrevData: {
      type: Object,
      default: () => {}
    },
    isFirefox: {
      type: Boolean,
      default: false
    },
    isAndroidOs: {
      type: Boolean,
      default: false
    },
    isIce: {
      type: Boolean,
      default: false
    },

    //getters
    getNotIncludeCoverDataImageCount: {
      type: Number,
      default: 0
    },

    //actions
    sortImages: {
      type: Function,
      default: () => {}
    },
    deleteDraftImage: {
      type: Function,
      default: () => {}
    },
    postFrontCoverImage: {
      type: Function,
      default: () => {}
    },
    postBackCoverImage: {
      type: Function,
      default: () => {}
    },
    postDraftStaticImage: {
      type: Function,
      default: () => {}
    },
    setInitialStaticImageData: {
      type: Function,
      default: () => {}
    },
    deleteStaticImageData: {
      type: Function,
      default: () => {}
    },
    putBlankArea: {
      type: Function,
      default: () => {}
    },
    deleteBlankArea: {
      type: Function,
      default: () => {}
    },
    putBlankStaticCoverBack: {
      type: Function,
      default: () => {}
    },

    //mutations
    setIsBusy: {
      type: Function,
      default: () => {}
    },
    setIsBusyNormal: {
      type: Function,
      default: () => {}
    },
    updateUserFrontCoverImageUrl: {
      type: Function,
      default: () => {}
    },
    updateUserBackCoverImageUrl: {
      type: Function,
      default: () => {}
    },
    updateFrontCoverType: {
      type: Function,
      default: () => {}
    },
    updateBackCoverType: {
      type: Function,
      default: () => {}
    },
    refreshImages: {
      type: Function,
      default: () => {}
    },
    updateIsSetFrontCoverNext: {
      type: Function,
      default: () => {}
    },
    updateIsSetBackCoverPrev: {
      type: Function,
      default: () => {}
    },
    updateFrontCoverNextData: {
      type: Function,
      default: () => {}
    },
    updateBackCoverPrevData: {
      type: Function,
      default: () => {}
    },
    updateCoverProcess: {
      type: Function,
      default: () => {}
    },
    updatePageProgressionDirection: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      showDetailModal: false,
      addImageDialog: false,
      staticImageDialog: false,
      uploadStaticImageType: "",
      detailImage: {},
      beforeImages: [],
      selectFrontCoverImageDialog: false,
      selectBackCoverImageDialog: false,
      frontCoverDefaultImage: CoverDefault,
      backCoverDefaultImage: CoverDefault,
      errorMessages: []
    };
  },

  methods: {
    coverImageFileName(element, key) {
      switch (key) {
        case "frontCoverImage":
        default:
          return this.frontCoverType === COVER_TYPE_SIMPLE
            ? this.lang.default_cover_name
            : element.fileName;
        case "backCoverImage":
          return this.backCoverType === COVER_TYPE_SIMPLE
            ? this.lang.default_cover_name
            : element.fileName;
      }
    },
    openDetailStaticImage: function(index, imageId, value) {
      this.staticImageDialog = true;
      this.uploadStaticImageType = value;
      this.$data.detailImage = { index };
    },
    onClickStaticImageFile() {
      this.$refs.staticImageFileInput.click();
    },
    onChangeStaticImageFileInput(e) {
      const files = e.target.files;
      this.errorMessages = [];

      if (files[0] == undefined) {
        this.staticImageDialog = false;
        return;
      }

      const file = files[0];

      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        const message = this.lang.image_add_error_file_type.replace(
          ":filename",
          file.name
        );
        this.errorMessages.push(message);
        return;
      }

      if (file.size > MAX_IMAGE_FILE_SIZE) {
        const message = this.lang.image_add_error_image_size
          .replace(":filename", file.name)
          .replace(":max_size", MAX_IMAGE_FILE_SIZE_HUMAN);
        this.errorMessages.push(message);
        return;
      }

      const imagePreviewUrl =
        ua.getBrowser().name === "IE" ? "" : URL.createObjectURL(file);

      const isFrontNext = this.uploadStaticImageType === "frontNext";
      const staticImageId = isFrontNext
        ? this.frontCoverNextData.imageId
        : this.backCoverPrevData.imageId;
      this.setIsBusy(true);

      if (ua.getBrowser().name === "IE") {
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.onload = () => {
          this.staticImageDialog = false;
          this.postDraftStaticImage({
            preImageId: staticImageId,
            isBlank: false,
            name: file.name,
            url: imagePreviewUrl,
            file: file,
            isBody: true,
            isFrontNext: isFrontNext
          }).then(
            () => {
              URL.revokeObjectURL(imagePreviewUrl);
              // ソート処理の実行
              // props だと反映されていないため直接参照
              const images = this.$store.state.uploadContents.images;

              this.sortImages({
                draftId: this.draftId,
                afterImages: images,
                beforeImages: images
              }).then(() => {
                this.setIsBusy(false);
              });
              if (isFrontNext) {
                this.updateIsSetFrontCoverNext(true);
              } else {
                this.updateIsSetBackCoverPrev(true);
              }
            },
            () => {
              this.setIsBusy(false);
            }
          );
        };
      } else {
        loadImageWithOrientationCorrection(file).then(canvas => {
          this.staticImageDialog = false;
          this.postDraftStaticImage({
            preImageId: staticImageId,
            isBlank: false,
            name: file.name,
            url: canvas.toDataURL(),
            file: dataUrlToBlob(canvas.toDataURL()),
            isBody: true,
            isFrontNext: isFrontNext
          }).then(
            () => {
              // ソート処理の実行
              // props だと反映されていないため直接参照
              const images = this.$store.state.uploadContents.images;

              this.sortImages({
                draftId: this.draftId,
                afterImages: images,
                beforeImages: images
              }).then(() => {
                this.setIsBusy(false);
              });
              if (isFrontNext) {
                this.updateIsSetFrontCoverNext(true);
              } else {
                this.updateIsSetBackCoverPrev(true);
              }
            },
            () => {
              this.setIsBusy(false);
            }
          );
        });
      }
    },
    onClickAddImageDialog() {
      if (this.isPanel) {
        this.updatePageProgressionDirection("single");
        this.updateFrontCoverType("user_upload");
        this.updateCoverProcess("canvas_nonprocessed");
      }
      this.addImageDialog = !this.addImageDialog;
    },
    async onClickUpdatePageProgressionDirection(value) {
      this.updatePageProgressionDirection(value);
      this.setIsBusyNormal(true);
      if (this.getNotIncludeCoverDataImageCount === 0) {
        this.setIsBusyNormal(false);
        return;
      }
      if (value === "vertical") {
        await this.deleteStaticImageData();
      } else {
        await this.setInitialStaticImageData();
      }
      this.refreshImages();
      this.setIsBusyNormal(false);

      this.$nextTick(() => {
        this.sortImages({
          draftId: this.draftId,
          afterImages: this.myImages,
          beforeImages: this.myImages
        });
      });
    },
    beforeMove: function(evt) {
      return (
        !evt.relatedContext.element.notMove &&
        !evt.draggedContext.element.notMove
      );
    },
    isActiveImage: function(index) {
      log.debug("isActiveImage index:", index);
      const image = this.myImages[index];
      return image.imageId > 0 && !image.isDeleting;
    },
    onClickDeleteDraftImage: async function(imageId, image) {
      if (image.staticImageName === "frontCoverNextImage") {
        this.staticImageDialog = false;
        this.updateIsSetFrontCoverNext(false);
        await this.deleteDraftImage(imageId);
        await this.putBlankStaticCoverBack({
          preImageId: imageId,
          isFrontNext: true
        });
      } else if (image.staticImageName === "backCoverPrevImage") {
        this.staticImageDialog = false;
        this.updateIsSetBackCoverPrev(false);
        await this.deleteDraftImage(imageId);
        await this.putBlankStaticCoverBack({
          preImageId: imageId,
          isFrontNext: false
        });
      } else {
        this.showDetailModal = false;
        await this.deleteDraftImage(imageId);
        const isContainsBlankArea =
          this.$store.state.uploadContents.images.filter(
            image => image.staticImageName === "blankArea"
          ).length > 0;
        if (isContainsBlankArea) {
          await this.putBlankArea();
        } else {
          await this.deleteBlankArea();
        }
      }

      this.$nextTick(() => {
        if (this.myImages.length > 0) {
          this.sortImages({
            draftId: this.draftId,
            afterImages: this.myImages,
            beforeImages: this.myImages
          });
        }
      });
    },
    openDetailImage: function(index) {
      const image = this.myImages[index];

      if (image.imageId > 0 && !image.isDeleting) {
        this.$data.showDetailModal = true;
        this.$data.detailImage = { index };
      }
    },
    hasMargin: function(index) {
      if (this.isPanel) {
        return true;
      }
      switch (this.pageProgressionDirection) {
        case "ltr":
          return !(index % 2);
        case "rtl":
          return index % 2;
        case "vertical":
          return true;
      }
    },
    getNextImage: function() {
      switch (this.pageProgressionDirection) {
        case "rtl":
          return this.detailImage.index--;
        case "ltr":
        case "vertical":
          return this.detailImage.index++;
      }
    },
    getPrevImage: function() {
      switch (this.pageProgressionDirection) {
        case "rtl":
          return this.detailImage.index++;
        case "ltr":
        case "vertical":
          return this.detailImage.index--;
      }
    },
    updateShowCoverDialog(event) {
      if (event.isFront) {
        this.selectFrontCoverImageDialog = event.showDialog;
      } else {
        this.selectBackCoverImageDialog = event.showDialog;
      }
    }
  },
  computed: {
    isShowPrev: function() {
      if (this.isPanel) {
        return "";
      }
      switch (this.pageProgressionDirection) {
        case "rtl":
          return (
            this.detailImage.index - 1 < this.getNotIncludeCoverDataImageCount
          );
        case "ltr":
          return this.detailImage.index > 2;
        case "vertical":
          return this.detailImage.index > 0;
      }
      return "";
    },
    isShowNext: function() {
      if (this.isPanel) {
        return "";
      }
      switch (this.pageProgressionDirection) {
        case "rtl":
          return this.detailImage.index > 2;
        case "ltr":
          return (
            this.detailImage.index - 1 < this.getNotIncludeCoverDataImageCount
          );
        case "vertical":
          return this.detailImage.index < this.myImages.length - 1;
      }
      return "";
    },
    imageSize: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return { width: "66px", height: "93px" };
        case "md":
          return { width: "108px", height: "152px" };
        default:
          return { width: "118px", height: "172px" };
      }
    },
    coverImageSize: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "sm":
        case "xs":
          return "200px";
        default:
          return "300px";
      }
    },
    frontCoverPageAreaMargin() {
      if (this.$vuetify.breakpoint.xs) {
        return "px-4";
      }

      if (this.$vuetify.breakpoint.sm) {
        return this.pageProgressionDirection === "rtl" ? "pl-3" : "pr-3";
      }

      return this.pageProgressionDirection === "rtl" ? "pl-4" : "pr-4";
    },
    coverPageAreaBorderSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return { width: "86px", height: "117px" };
        case "md":
          return { width: "138px", height: "184px" };
        default:
          return { width: "148px", height: "204px" };
      }
    },
    facingPageAreaBorderSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return { width: "152px", height: "117px" };
        case "md":
          return { width: "246px", height: "184px" };
        default:
          return { width: "266px", height: "204px" };
      }
    },
    imageLeftAndRightMargin() {
      return function(value) {
        if (this.isPanel || this.pageProgressionDirection === "vertical") {
          return;
        }

        if (value) {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
            case "sm":
              return this.pageProgressionDirection === "rtl"
                ? { "margin-left": "30px" }
                : { "margin-right": "30px" };
            case "md":
              return this.pageProgressionDirection === "rtl"
                ? { "margin-left": "34px" }
                : { "margin-right": "34px" };
            default:
              return this.pageProgressionDirection === "rtl"
                ? { "margin-left": "40px" }
                : { "margin-right": "40px" };
          }
        } else {
          switch (this.$vuetify.breakpoint.name) {
            case "xs":
              return this.pageProgressionDirection === "rtl"
                ? { "margin-right": "24px" }
                : { "margin-left": "24px" };
            case "sm":
            default:
              return this.pageProgressionDirection === "rtl"
                ? { "margin-left": "0" }
                : { "margin-right": "0" };
          }
        }
      };
    },
    lastImageMargin() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return this.pageProgressionDirection === "rtl"
            ? { "padding-left": "14px" }
            : { "padding-right": "14px" };
        default:
          return this.pageProgressionDirection === "rtl"
            ? { "padding-left": "20px" }
            : { "padding-right": "20px" };
      }
    },
    wrapperWidth: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
        case "xl":
          return "850px";
        case "md":
          return "770px";
        case "sm":
          return "500px";
        case "xs":
        default:
          return "200px";
      }
    },
    flexDirection: function() {
      if (this.isPanel) {
        return "";
      }
      switch (this.pageProgressionDirection) {
        case "ltr":
          return "row";
        case "rtl":
          return "row-reverse";
        case "vertical":
          return "row";
      }
      return "";
    },
    myImages: {
      get() {
        return this.images;
      },
      set(afterImages) {
        this.sortImages({
          draftId: this.draftId,
          afterImages,
          beforeImages: this.images
        });
      }
    },
    imageAddNote() {
      let maxImageNum = 200;
      if (this.isPanel) {
        maxImageNum = 1;
      }

      return this.lang.image_add_note
        .replace(":max_size", 32)
        .replace(":num", maxImageNum);
    },
    isBlankImageOnly() {
      return (
        this.images.filter(image => {
          return image.src !== undefined;
        }).length === 0
      );
    },
    frontCoverImageUrl() {
      return this.frontCoverType === "simple"
        ? this.frontCoverDefaultImage
        : this.userFrontCoverImageUrl;
    },
    backCoverImageUrl() {
      return this.backCoverType === "simple"
        ? this.backCoverDefaultImage
        : this.userBackCoverImageUrl;
    },
    checkMobile() {
      if (ua.getBrowser().name === "IE") {
        return false;
      } else if (JSON.stringify(ua.getDevice()) === "{}") {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<!-- Add "module" attribute to limit CSS to this component only -->
<style module lang="scss">
.pageProgressionDirection__item {
  margin-right: 12px;
}

.pageProgressionDirection__item > div {
  justify-content: center;
  margin-left: 0;
  margin-right: 0;
  > div {
    margin: 0;
  }
}

.pageProgressionDirection__item img {
  cursor: pointer;
}

.imageEditArea {
  position: relative;
}

.imageEditAreaContainer {
  position: relative;
  z-index: 1;
}

.pages {
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
}

.detailImageWrapper {
  position: relative;
  text-align: center;
}

.left {
  left: 5px;
}

.right {
  right: 5px;
}

.detailPreviewImage {
  max-width: 320px;
  max-height: 440px;
  overflow: hidden;
}

.detailImageButton {
  position: absolute;
  top: 50%;
  z-index: 1;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.listImage {
  cursor: grab;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  min-height: 80px;
  max-width: 100%;
  max-height: 100%;
  transform: translateX(-50%) translateY(-50%);
}

.panelImage {
  cursor: pointer;
  max-width: 240px;
  max-height: 380px;
}

.coverImage {
  cursor: grab;
  position: absolute;
  width: auto;
  height: auto;
  top: 0;
  left: 0;
  min-height: 80px;
  max-width: 100%;
  max-height: 100%;
}

.imageWrapper {
  position: relative;
}

.panelImageWrapper {
  line-height: 0;
  position: relative;
}

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.imageItem {
  list-style-type: none;
  padding-top: 10px;
  margin-bottom: 48px;
}

.borderPosition {
  position: relative;
}

.facingPageBorderArea {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.facingPageBorder {
  position: absolute;
  top: -16px;
  left: -15px;
  border: solid 4px black;

  @media screen and (max-width: 960px) {
    top: -12px;
    left: -10px;
  }
}

.facingPageBorderPageText {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  height: 2.8rem;
  position: absolute;
  top: -60px;
  left: 0;
  line-height: 1.2rem;
}

.coverImageBorder {
  position: absolute;
  top: -16px;
  left: -15px;
  border: solid 4px black;

  @media screen and (max-width: 960px) {
    top: -12px;
    left: -10px;
  }
}

.noMargin {
  padding-right: 0;
}

.hasMargin {
  padding-right: 18px;
}

.page-number-wrapper {
  padding-top: 16px;
  font-size: 0.5rem;
  width: 100%;
  word-wrap: break-word;
  white-space: normal;
  text-align: center;
}

.btnTextStyle {
  text-transform: none !important;
}

.dragGhostItem {
  opacity: 0.5;
}
</style>
